import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './AddEntityWatcherButtonContainer';
import { getWatcherEntityLabel } from '../../WatchersUtils';
import { PrimaryButton, SecondaryButton } from '../../../components/button';
import { withUser } from '../../../user/UserContext';
import { UserContextType } from '../../../user/user.types';
import { DeleteWatcherButton } from '../delete-watcher-button/DeleteWatcherButton';
import { WatcherEntitityId } from '../../watchers.types';
import { withModal, WithModalProps } from '../../../components/modal/withModal';
import { DeleteWatcherModal } from '../../delete/DeleteWatcherModal';

type Props = {
  query: string;
  entityIdParams: WatcherEntitityId;
  uniqueId: string;
  restrict: () => void;
  source: string;
  onButtonClick?: Function;
  secondary?: boolean;
} & UserContextType &
  PropsFromRedux &
  WithModalProps;

export class RawAddEntityWatcherButton extends React.Component<Props> {
  static defaultProps = {
    onButtonClick: () => {},
    secondary: false,
  };

  onDeleteWatcher = async () => {
    const {
      onButtonClick,
      deleteUserEntityWatcher,
      uniqueId,
      source,
    } = this.props;
    if (onButtonClick) {
      onButtonClick();
    }
    try {
      await deleteUserEntityWatcher({ uniqueId, source });
    } catch (error) {
      throw error;
    }
  };

  deleteWatcher = () => {
    const { openModal } = this.props;
    openModal((modalProps) => (
      <DeleteWatcherModal
        deleteWatcher={this.onDeleteWatcher}
        {...modalProps}
      />
    ));
  };

  addWatcher = async () => {
    const {
      onButtonClick,
      createUserEntityWatcher,
      query,
      entityIdParams,
      uniqueId,
      source,
    } = this.props;
    if (onButtonClick) {
      onButtonClick(true);
    }

    try {
      await createUserEntityWatcher({
        query,
        uniqueId,
        source,
        entityIdParams,
      });
    } catch (error) {
      throw error;
    }
  };

  render() {
    const {
      restrict,
      accessPremium,
      isWatched,
      secondary,
      entityIdParams,
      uniqueId,
    } = this.props;

    const creationProps = {
      onClick: !accessPremium && restrict ? restrict : this.addWatcher,
      iconLeft: 'notifications_none',
    };
    const entityLabel = getWatcherEntityLabel(entityIdParams);

    return (
      <>
        {!isWatched && (
          <>
            {!secondary && (
              <PrimaryButton {...creationProps}>
                <FormattedMessage id="watchers/components/add-entity-watcher/AddEntityWatcherButton.tsx/1" />
                {entityLabel}
              </PrimaryButton>
            )}
            {secondary && (
              <SecondaryButton {...creationProps}>
                <FormattedMessage id="watchers/components/add-entity-watcher/AddEntityWatcherButton.tsx/2" />
                {entityLabel}
              </SecondaryButton>
            )}
          </>
        )}
        {isWatched && (
          <DeleteWatcherButton
            deleteWatcher={
              !accessPremium && restrict ? restrict : this.deleteWatcher
            }
            tooltipId={`add-watcher-entity-${uniqueId}`}
          />
        )}
      </>
    );
  }
}

export const AddEntityWatcherButton = Connect(
  withModal(withUser(RawAddEntityWatcherButton)),
);
